import React from 'react'

const FourChatsOption = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect className='custom-icon-stroke' x="2.40064" y="2.40015" width="8.29091" height="8.29091" rx="1.09091" stroke="white" strokeWidth="1.30909"/>
        <rect className='custom-icon-stroke' x="13.3088" y="2.40015" width="8.29091" height="8.29091" rx="1.09091" stroke="white" strokeWidth="1.30909"/>
        <rect className='custom-icon-stroke' x="2.40064" y="13.3093" width="8.29091" height="8.29091" rx="1.09091" stroke="white" strokeWidth="1.30909"/>
        <rect className='custom-icon-stroke' x="13.3088" y="13.3093" width="8.29091" height="8.29091" rx="1.09091" stroke="white" strokeWidth="1.30909"/>
    </svg>
  )
}

export default FourChatsOption
